<script setup>
import { computed, defineProps } from 'vue'
import { cn } from '@/lib/utils'
import { ToastViewport } from 'radix-vue'

const props = defineProps({
  class: { type: String, default: '' }
})

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props
  return delegated
})
</script>

<template>
  <ToastViewport 
    v-bind="delegatedProps" 
    :class="cn(
      'fixed bottom-0 right-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:max-w-[420px]', 
      props.class
    )" 
  />
</template> 